import { useOverlays } from "contexts/OverlayContext";
import { useIsCategoryGlMappingEnabled } from "@hooks/useIsCategoryGlMappingEnabled";
import { PlainModal } from "@design-system/Modal/Modal";
import { UpdateCategoryModal } from "./UpdateCategoryModal";
import { isCustomBusinessSubcategory } from "./categoryGlGridEligibility";

export const UpdateCategoryModalContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const isGlMappingEnabled = useIsCategoryGlMappingEnabled();
    const overlayInfo = getOverlayInfo("updateCategory");

    if (!overlayInfo?.data) {
        return null;
    }

    const { category } = overlayInfo.data;
    const isGridEnabled =
        isGlMappingEnabled && isCustomBusinessSubcategory(category);

    return (
        <PlainModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            size={isGridEnabled ? "lg" : "md"}
        >
            <UpdateCategoryModal
                key={category.id}
                category={category}
                onHide={closeOverlay}
            />
        </PlainModal>
    );
};
